<template>
  <div class="category">
    <section class="slider-container">
      <h2 class="slider-heading">{{ title }}</h2>
      <div class="pl-5rm">
        <div v-if="category_data.length > 0">
          <carousel :margin="5" :loop="false" :navText="['', '']" :rewind="false" :responsive="{
            0: {
              items: 3,
              nav: true
            },
            600: {
              items: 3,
              nav: true
            },
            1000: {
              items: 7,
              nav: true,
            }

          }" :slideBy="4">
            <div class="item" v-for="(video, index) in category_data" :key="index">
              <div class="series-block" @click="goToPlayer(video)">
                <img class="img-fluid" :src="video.thumbnail.large" alt="" />
                <div class="more-cnt text-center">
                  <h5 class="pt-3" style="margin-top: 0rem !important">
                    {{ video.name | trim }}
                  </h5>
                  <p class="py-2" v-if="video.metaData.running_time">Duration {{ video.metaData.running_time }}</p>
                  <p class="py-3">{{ getDesc(video) }}</p>
                  <div class="d-flex justify-content-between">
                    <a class="border circle-Sm" @click="voteVideo(video, true)">
                      <img class="like" src="../assets/img/like.svg" alt="" />
                    </a>
                    <a class="border circle-Sm" @click="voteVideo(video, false)">
                      <img class="unlike" src="../assets/img/unlike.svg" alt="" />
                    </a>
                    <a class="border circle-Sm" @click="toggleFavorited(video)">
                      <img src="../assets/img/minis-icon.svg" v-if="my_favourite(video)" alt="" class="plus-icon" />
                      <img class="plus-icon" src="../assets/img/plus.svg" v-else />
                    </a>
                  </div>
                  <div class="py-4 d-flex justify-content-center">
                    <a class="d-inline-block">
                      <img src="../assets/img/play.svg" @click="playvideo(video)" class="play" alt="" />
                    </a>
                  </div>
                  <div class="pt-2 d-flex justify-content-center">
                    <a @click="goToDetails(video)" class="d-inline-block btn btn-outline-light">
                      More
                      <i class="fa fa-angle-right ml-2" aria-hidden="true"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </carousel>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import carousel from "vue-owl-carousel";
import Helpers from "../Mixins/Helpers.js";
export default {
  name: "category",
  components: {
    carousel,
  },
  props: ["title", "apiOptions"],
  filters: {
    trim: function (value) {
      if (value.length > 20) {
        return value.substring(0, 20) + "...";
      } else {
        return value;
      }
    },
  },
  mixins: [Helpers],
  data() {
    return {
      category_data: {},
      show_right: false,
      duidVal: null,
    };
  },
  computed: {
    myListItems() {
      return this.$store.state.user.mylist;
    },
    isFavorited(show) {
      for (var i = 0; i < this.$store.state.user.mylist.length; i++) {
        var item = this.$store.state.user.mylist[i];
        if (item.id == show.id) return true;
      }
      return false;
    },
  },
  methods: {
    getDesc(video) {
      if (video.name.length > 20) {
        if (video.name.length > 30) {
          return "";
        } else {
          return video.description.substring(0, 20) + "...";
        }
      } else {
        return video.description.substring(0, 30) + "...";
      }
    },
    voteVideo(show, status) {
      this.$store
        .dispatch("voteVideo", {
          id: show.id,
          status: status,
        })
        .then((res) => { });
    },
    my_favourite(show) {
      for (var i = 0; i < this.$store.state.user.mylist.length; i++) {
        var item = this.$store.state.user.mylist[i];
        if (item.id == show.id) return true;
      }
      return false;
    },
    toggleFavorited(show) {
      this.$store.commit("refreshMyList", false);
      if (this.my_favourite(show)) {
        this.$store
          .dispatch("updatemyList", {
            id: show.id,
            value: false,
            type: show.type,
          })
          .then(() => {
            // this.$store.commit("refreshMyList" ,true)
          });
      } else {
        this.$store
          .dispatch("updatemyList", {
            id: show.id,
            value: true,
            type: show.type,
          })
          .then(() => {
            //this.$store.commit("refreshMyList" ,true)
          });
      }
    },
    getparentId() {
      return this.apiOptions;
    },
    getHrefToDetails(movie, parent) {
      if (this.apiOptions == "mylist") {
        return "/details/" + movie + "/" + this.apiOptions;
      } else {
        return "/details/" + movie + "/" + this.apiOptions;
      }
    },
    goToDetails(current) {
      var dynamicRoute = "";
      if (current.type == "vod") {
        dynamicRoute = "/details/" + current.id + "/" + this.parent;
      } else if (current.type == "Season") {
        dynamicRoute = "/playlistdetails/" + current.id;
      } else if (current.type == "Series") {
        dynamicRoute = "/detailseries/" + current.id;
      }
      this.$router.push("" + dynamicRoute);
    },
    goToPlayer(video) {
      if (this.isPlatformMobile() == true || this.isPlatformTablet() == true) {
        this.goToDetails(video);
      }
    },
    playvideo(current) {
      this.checkSubs(current);
    },

    checkSubs(current) {
      this.$store
        .dispatch("getVideoPlaybackURLV2", {
          videoId: current.id,
          deviceId: this.duidVal,
        })
        .then((res) => {
          if (current.type == "Series") {
            var currentCat = current.id;
            this.$store.dispatch("getCatalougeById", currentCat).then((res) => {
              var currentSeason = res._embedded.items[0].id;
              this.$store
                .dispatch("getCatalougeById", currentSeason)
                .then((res) => {
                  var currentSeasonVideoId = res._embedded.items[0].id;
                  var dynamicRoute = "/viewvideo/" + currentSeasonVideoId;
                  this.$router.push("" + dynamicRoute);
                });
            });
          } else {
            var dynamicRoute = "/viewvideo/" + current.id;
            this.$router.push("" + dynamicRoute);
          }
        })
        .catch((err) => {
          if (err.response.data.error.status == "422") {
            // show upgrade screen popup
          }
          if (err.response.data.error.status == "403") {
            this.$store.commit("showPopup", true);
            this.$store.commit("showdefaultFooter", false)
            window.scrollTo(0, 0);
          }
          if (err.response.data.error.status == "404 ") {
            //this.$store.commit("setNotification", "Please try again later ");
            this.$store.commit("showPopup", true);
            window.scrollTo(0, 0);
          }
          this.$store.commit("setLoader", false);
        });
    },
    scrollLeft(amount) {
      this.scroll = setInterval(
        () => (this.$refs.scroller.scrollLeft += amount),
        5
      );
    },
    clearScroll() {
      clearInterval(this.scroll);
    },

  },
  created() {
    this.$store.commit("showPopup", false);
    this.parent = this.apiOptions;
    if (this.apiOptions == "mylist") {
      this.category_data = this.myListItems;
    } else {
      this.$store.dispatch("getCatalougeById", this.apiOptions).then((res) => {
        this.category_data = res._embedded.items;
      });
    }
  },
};
</script>

<style scoped>
a:hover {
  cursor: pointer;
}

.owl-next::before {
  font-size: 32px !important;
}

.owl-prev::before {
  font-size: 32px !important;
}

.owl-nav .disabled {
  display: none;
}
</style>
<style>
.owl-next,
.owl-prev {
  cursor: pointer;
}

.owl-next::before {
  font-size: 26px !important;
  position: absolute;
  top: 22%;
  left: 32%;
}

.owl-prev::before {
  font-size: 26px !important;
  position: absolute;
  top: 22%;
  left: 32%;
}
</style>
